
import { defineComponent, computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";

import ApiService from "@/core/services/ApiService";
import { MenuComponent } from "@/assets/ts/components";

export default defineComponent({
  name: "merchant-overview",
  components: {},
  setup() {
    onMounted(async () => {
      setTimeout(async () => {
        await getApis();
        let res;
        try {
          res = await ApiService.get(`knowledge/alerts?limit=3`);
          alerts.value = res.data.data;
        } catch {
          alerts.value = [];
        }

        try {
          res = await ApiService.get(`knowledge/merchants?limit=3`);
          merchants.value = res.data.data;
        } catch {
          merchants.value = [];
        }

        try {
          res = await ApiService.get(`knowledge/apis?limit=3`);
          apis.value = res.data.data;
        } catch {
          apis.value = [];
        }

        try {
          res = await ApiService.get(`knowledge/chargebacks?limit=3`);
          chargebacks.value = res.data.data;
        } catch {
          chargebacks.value = [];
        }

        try {
          res = await ApiService.get(
            `merchants/accounts?merchant_id=${getMerchantId.value}`
          );
          merchant.value = res.data.data[0];
        } catch {
          merchant.value = {};
        }
        res = await ApiService.get(
          `chargebacks/chargebacksby.reasoncategory?merchant_id=${getMerchantId.value}&reason_category=Authorization`
        );
        if (res.data.data) {
          totalAuthorizationChargebacks.value = Number(res.data.data[0].count);
          authorizationCategory.value = res.data.data[0].reason_category;
          nameMonth.value = res.data.data[0].month;
        }
        if (authorizationCategory.value == "") {
          authorizationCategory.value = "Authorization";
        }
        res = await ApiService.get(
          `chargebacks/chargebacksby.reasoncategory?merchant_id=${getMerchantId.value}&reason_category=Fraud`
        );
        if (res.data.data) {
          totalFraudChargebacks.value = Number(res.data.data[0].count);
          fraudCategory.value = res.data.data[0].reason_category;
        }
        if (fraudCategory.value == "") {
          fraudCategory.value = "Fraud";
        }
        res = await ApiService.get(
          `chargebacks/chargebacksby.reasoncategory?merchant_id=${getMerchantId.value}&reason_category=Processing Error`
        );
        if (res.data.data) {
          totalProcessingChargebacks.value = Number(res.data.data[0].count);
          processingCategory.value = res.data.data[0].reason_category;
        }
        if (fraudCategory.value == "") {
          fraudCategory.value = "Fraud";
        }
        res = await ApiService.get(
          `chargebacks/chargebacksby.reasoncategory?merchant_id=${getMerchantId.value}&reason_category=Consumer Dispute`
        );
        if (res.data.data) {
          totalConsumerChargebacks.value = Number(res.data.data[0].count);
          consumerCategory.value = res.data.data[0].reason_category;
        }
        if (consumerCategory.value == "") {
          consumerCategory.value = "Consumer Dispute";
        }

        res = await ApiService.get(
          `reports/chargebacks/incoming.overview?merchant_id=${getMerchantId.value}`
        );
        incomingOverview.value = res.data.data[0];

        if (incomingOverview.value.total_count === 0) {
          incomingProgress.value = "0";
        } else {
          incomingProgress.value = (
            (incomingOverview.value.sent_count /
              incomingOverview.value.total_count) *
            100
          ).toFixed(0);
        }
        res = await ApiService.get(
          `chargebacks/chargebacksby.merchant?merchant_id=${getMerchantId.value}`
        );
        if (res.data.data) {
          overAllTotal.value = Number(res.data.data[0].overall_total);
          visaTotal.value = Number(res.data.data[0].visa);
          mastercardTotal.value = Number(res.data.data[0].mastercard);
          discoverTotal.value = Number(res.data.data[0].discover);
          amexTotal.value = Number(res.data.data[0].amex);
          averageAmount.value = Number(res.data.data[0].average_amount);
          recovered.value = Number(res.data.data[0].recovered);
        }

        res = await ApiService.get(
          `reports/transactions/transactions.monthly?merchant_id=${getMerchantId.value}&action_type=refund&month=${monthName}`
        );
        if (res.data.data) {
          totalRefunds.value = Number(res.data.data[0].count);
        }
        res = await ApiService.get(
          `reports/transactions/transactions.overview?merchant_id=${getMerchantId.value}&action_type=sale&month=${monthName}`
        );
        if (res.data.data) {
          totalSales.value = Number(res.data.data[0].count);
        }

        if (totalSales.value === 0) {
          cbratio.value = "0";
        } else {
          cbratio.value = (
            (totalChargebacks.value / totalSales.value) *
            100
          ).toFixed(2);
        }

        reInitializeMenus();
      }, 1000);
    });
    const connectedApis = ref([]);
    const getApis = async () => {
      try {
        const { data } = await ApiService.get(
          "apis/apis.merchants?category=Cloud"
        );

        if (data.success) {
          connectedApis.value = data.data;
        }
      } catch (e) {
        connectedApis.value = [];
      }
    };

    const reInitializeMenus = () => {
      setTimeout(() => {
        MenuComponent.reinitialization();
      }, 0);
    };
    const getLastSentDate = computed(() => {
      const date = incomingOverview.value.last_date_sent.split(" ")[0];
      const partDate = date.split("-");
      return `${partDate[0]}-${partDate[1]}-${partDate[2]}`;
    });
    const route = useRoute();
    const getMerchantId = computed(() => {
      return route.params.id;
    });
    const totalSales = ref(0);
    const totalRefunds = ref(0);
    const cbratio = ref("0");
    const nameMonth = ref("");
    const totalChargebacks = ref(0);
    const totalAuthorizationChargebacks = ref(0);
    const authorizationCategory = ref("");
    const totalProcessingChargebacks = ref(0);
    const processingCategory = ref("");
    const overAllTotal = ref(0);
    const visaTotal = ref(0);
    const mastercardTotal = ref(0);
    const discoverTotal = ref(0);
    const amexTotal = ref(0);
    const recovered = ref(0);
    const averageAmount = ref(0);
    const totalFraudChargebacks = ref(0);
    const fraudCategory = ref("");
    const totalConsumerChargebacks = ref(0);
    const consumerCategory = ref("");
    const alerts = ref([]);
    const merchants = ref([]);
    const apis = ref([]);
    const chargebacks = ref([]);
    const incomingOverview = ref({
      notsent_count: 0,
      sent_count: 0,
      total_count: 0,
      last_date: "",
      last_date_sent: "",
    });
    const incomingProgress = ref("0");
    const merchant = ref({});
    const d = new Date();
    const monthName = d.toLocaleString("default", { month: "long" });
    const onNewApiSubmit = () => {
      getApis();
    };
    return {
      processingCategory,
      totalProcessingChargebacks,
      consumerCategory,
      totalConsumerChargebacks,
      totalFraudChargebacks,
      fraudCategory,
      getMerchantId,
      overAllTotal,
      amexTotal,
      visaTotal,
      averageAmount,
      recovered,
      mastercardTotal,
      discoverTotal,
      totalSales,
      totalRefunds,
      cbratio,
      totalChargebacks,
      getLastSentDate,
      alerts,
      merchants,
      apis,
      chargebacks,
      incomingOverview,
      incomingProgress,
      merchant,
      nameMonth,
      monthName,
      totalAuthorizationChargebacks,
      authorizationCategory,
      onNewApiSubmit,
    };
  },
});
